import React, { useEffect, useState } from 'react';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { detectMobile, scrollToTop } from '../../utils/UiHelper';
import * as UiSportOverviewActions from 'actions/UiSportOverviewActions';
import ViewToggleListToolbar from '../../components/ViewToolbars/ViewToggleListToolbarNew';
import { validateUrlParams } from '../../utils/Helper';
import { eventListSorter, getGroupEventList } from './helper';
import { ViewEventListContainer } from '../ViewEventList/styled';
import GroupEventItemHeader from '../../components/GroupEventItemHeader/GroupEventItemHeader';
import GroupEventItemList from '../../components/GroupEventItemList/GroupEventItemList';
import { ViewTournamentListWrapper } from './styled';
import { BoxRoundedBorderBottom } from '../../styled';

const ViewTournamentItemsNew = (props) => {
    const [groupsStatus, setGroupsStatus] = useState({});
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        if (props.listType === 'toggle') {
            let groupStatusLocal = { ...props.tournamentViewStatus };
            let isOpenedFirstItem = false;

            let data = Object.values(props.data).sort((a, b) => {
                if (a.priority !== b.priority) return a.priority - b.priority;
                return a.name.localeCompare(b.name);
            });

            data.forEach((item) => {
                const key = item.id;
                if (groupStatusLocal[key] === undefined) {
                    groupStatusLocal[key] = false;
                    if (
                        !isOpenedFirstItem &&
                        props.isFirstGroupOpened === 'yes'
                    ) {
                        groupStatusLocal[key] = true;
                        isOpenedFirstItem = true;
                        props.uiSportOverviewActions.setOverviewTournamentStatus(
                            groupStatusLocal
                        );
                    } else if (
                        props.tournament?.toString() === key.toString()
                    ) {
                        groupStatusLocal[key] = true;
                    }
                }
            });

            setGroupsStatus(groupStatusLocal);
        }

        return () => {
            props.uiSportOverviewActions.setOverviewTournamentStatus(
                groupsStatus
            );
        };
    }, []);

    useEffect(
        () => {
            setScrolled(false);
        },
        [props.tournament]
    );

    const buildNewPath = (tournamentId) => {
        const pathnameArray = window.location.pathname.split('/');
        const sport = encodeURIComponent(pathnameArray[1]);
        const category = encodeURIComponent(pathnameArray[2]);
        const tournamentData = props.data[tournamentId];
        const groupName = encodeURIComponent(
            tournamentData?.events?.[0]?.groupName
                .toLowerCase()
                .replace(/\s+/g, '-')
        );
        const tournamentName = encodeURIComponent(
            validateUrlParams(tournamentData.name)
        );
        return `/${sport}/${category}/${groupName}/${tournamentName}`;
    };

    const toggleHandler = (status, tournamentId) => {
        //TODO check comparison prev state and updated
        const updatedStatus = {
            ...groupsStatus,
            [tournamentId]: !props.tournamentViewStatus[tournamentId],
        };
        setScrollPosition(updatedStatus[tournamentId], tournamentId, scrolled);
        props.uiSportOverviewActions.setOverviewTournamentStatus(updatedStatus);
        setGroupsStatus(updatedStatus);

        if (status) {
            const newPath = buildNewPath(tournamentId);
            browserHistory.push(newPath);
            setScrolled(true);
        }
    };

    const setScrollPosition = (status, id, scrolled) => {
        if (status) {
            setTimeout(() => {
                let rect = document
                    .querySelector('#tournament-id-' + id)
                    ?.getBoundingClientRect();
                let elOffset = rect?.top + window.scrollY;
                let differences = detectMobile() ? 142 : 140;
                if (elOffset && differences) {
                    window.scrollTo({
                        top: elOffset - differences,
                        behavior: 'smooth',
                    });
                }
            }, 500);

            setScrolled(true);
        }
    };

    let data = Object.values(props.data).sort((a, b) => {
        if (a.priority > b.priority) {
            return 1;
        }

        if (a.priority < b.priority) {
            return -1;
        }

        if (a.name > b.name) {
            return 1;
        }
        if (a.name < b.name) {
            return -1;
        }

        return 0;
    });

    const listType = props.listType;

    const view = data.map((obj, key) => {
        const sortedEvents = eventListSorter(obj.events);
        const { header: headerOptions, eventsToRender } = getGroupEventList(
            sortedEvents,
            props.limit
        );

        const groupTitle = `${props.sport} • ${props.group.name} • ${obj.name}`;
        const openedToolbar = groupsStatus[obj.id] ? 'yes' : 'no';
        const isToogleListType = listType === 'toggle';
        const openedList = isToogleListType && openedToolbar === 'yes';
        const showList = openedList || !isToogleListType;

        const toolbarInfoIcon =
            props.sportInfo?.comp?.[obj.id]?.content ?? null;

        const tournamentList = (
            <>
                <GroupEventItemHeader
                    events={obj.events}
                    options={headerOptions}
                    title={groupTitle}
                    key={`header_${obj.id}`}
                />
                <GroupEventItemList
                    events={eventsToRender}
                    headerOptions={headerOptions}
                    key={`list_${obj.id}`}
                    limit={props.limit}
                />
            </>
        );

        return (
            <li id={`tournament-id-${obj.id}`} key={key}>
                {listType === 'toggle' && (
                    <ViewToggleListToolbar
                        title={obj.name}
                        tournamentId={obj.id}
                        toggleHandler={toggleHandler}
                        opened={openedToolbar}
                        infoIcon={toolbarInfoIcon}
                    />
                )}
                {showList &&
                    (listType === 'toggle' ? (
                        <BoxRoundedBorderBottom>
                            {tournamentList}
                        </BoxRoundedBorderBottom>
                    ) : (
                        tournamentList
                    ))}
            </li>
        );
    });

    return (
        <ViewEventListContainer>
            <ViewTournamentListWrapper
                $gap={listType === 'toggle' ? '8px' : '0'}
            >
                {view}
            </ViewTournamentListWrapper>
        </ViewEventListContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        tournamentViewStatus: state.uiSportOverview.tournamentViewStatus,
        tournamentId: state.uiSportOverview.tournamentId,
        danmarkItems: state.ui.danmarkItems,
        sportInfo: state.sportTree.sportInfo,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        uiSportOverviewActions: bindActionCreators(
            UiSportOverviewActions,
            dispatch
        ),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewTournamentItemsNew);
